module.exports = __webpack_public_path__ + "img/ikotun_icon.efc7ad58.png";